export default __webpack_public_path__ + "static/media/photo--sm--group.359ef05a.jpg";